// import { useEffect, useRef, useState } from 'react'
// import { Document, Page, pdfjs } from 'react-pdf'
// import {
//   Download,
//   Printer,
//   X,
//   ChevronLeft,
//   ChevronRight,
//   ArrowUpRight,
// } from 'lucide-react'

// import 'react-pdf/dist/Page/AnnotationLayer.css'
// import 'react-pdf/dist/Page/TextLayer.css'
// import { getFullFileUrl } from '../../../../../utils/devprodswitcher'

// // ✅ PDF.js worker
// // pdfjs.GlobalWorkerOptions.workerSrc = `https://unpkg.com/pdfjs-dist@4.4.168/build/pdf.worker.min.mjs`
// pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`

// const Spinner = () => (
//   <div className="flex items-center justify-center p-6">
//     <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-gray-300" />
//   </div>
// )

// const FilePreviewModal = ({ file, onClose }) => {
//   if (!file) return null

//   const safePreviewLink = getFullFileUrl(file.previewLink)
//   const { name, previewLink, type } = file

//   const [loading, setLoading] = useState(true)
//   const [error, setError] = useState(false)
//   const [numPages, setNumPages] = useState(null)
//   const [pageNumber, setPageNumber] = useState(1)
//   const [scale, setScale] = useState(1.2)
//   const [rotation, setRotation] = useState(0)
//   const iframeRef = useRef(null)

//   useEffect(() => {
//     setLoading(true)
//     setError(false)
//     setNumPages(null)
//     setPageNumber(1)
//     if (!previewLink) setError(true)
//     else setTimeout(() => setLoading(false), 300)
//   }, [previewLink, name])

//   const openInNewTab = (url) =>
//     window.open(url, '_blank', 'noopener,noreferrer')

//   // 🖨️ Enhanced Print Logic (PDF, Image, Office, Video, Text)
//   const handlePrint = async () => {
//     if (!safePreviewLink) return
//     const mime = type?.toLowerCase() || ''
//     const fileUrl = safePreviewLink

//     // --- PDF ---
//     if (mime === 'application/pdf' || name.endsWith('.pdf')) {
//       const w = window.open(fileUrl, '_blank')
//       if (w) w.addEventListener('load', () => w.print())
//       return
//     }

//     // --- Image ---
//     if (mime.startsWith('image/')) {
//       const w = window.open('', '_blank')
//       if (!w) return
//       const html = `
//         <html><head><title>${name}</title></head>
//         <body style="margin:0;display:flex;align-items:center;justify-content:center;background:#fff;">
//           <img src="${fileUrl}" style="max-width:100%;height:auto;" />
//           <script>setTimeout(()=>window.print(),500)</script>
//         </body></html>`
//       w.document.write(html)
//       w.document.close()
//       return
//     }

//     // --- Office ---
//     const viewer = getOfficeViewerUrl(fileUrl, mime)
//     if (viewer) {
//       const w = window.open(viewer, '_blank')
//       if (w) w.addEventListener('load', () => w.print())
//       return
//     }

//     // --- Video / Fallback ---
//     const w = window.open(fileUrl, '_blank')
//     if (w) w.addEventListener('load', () => w.print())
//   }

//   const handleDownload = () => {
//     if (!safePreviewLink) return
//     const a = document.createElement('a')
//     a.href = safePreviewLink
//     a.download = name || 'download'
//     a.click()
//   }

//   const zoomIn = () => setScale((s) => Math.min(s + 0.2, 3))
//   const zoomOut = () => setScale((s) => Math.max(s - 0.2, 0.5))
//   const resetZoom = () => setScale(1.2)
//   const rotate = () => setRotation((r) => (r + 90) % 360)

//   // 🧩 PDF Viewer
//   const renderPDF = () => (
//     <div className="flex flex-col h-[75vh] bg-gray-50">
//       <div className="flex items-center justify-between px-3 py-2 border-b bg-white">
//         <div className="flex items-center gap-2 text-sm">
//           <button
//             onClick={() => setPageNumber((p) => Math.max(1, p - 1))}
//             disabled={pageNumber <= 1}
//             className="p-2 rounded hover:bg-gray-100 disabled:opacity-40"
//           >
//             <ChevronLeft size={18} />
//           </button>
//           <span>
//             Page {pageNumber} of {numPages || '?'}
//           </span>
//           <button
//             onClick={() => setPageNumber((p) => Math.min(numPages || p, p + 1))}
//             disabled={numPages ? pageNumber >= numPages : true}
//             className="p-2 rounded hover:bg-gray-100 disabled:opacity-40"
//           >
//             <ChevronRight size={18} />
//           </button>
//         </div>
//         <div className="flex items-center gap-2">
//           <button
//             onClick={zoomOut}
//             className="px-2 py-1 border rounded hover:bg-gray-100"
//           >
//             -
//           </button>
//           <button
//             onClick={resetZoom}
//             className="px-2 py-1 border rounded hover:bg-gray-100"
//           >
//             {Math.round(scale * 100)}%
//           </button>
//           <button
//             onClick={zoomIn}
//             className="px-2 py-1 border rounded hover:bg-gray-100"
//           >
//             +
//           </button>
//           <button
//             onClick={rotate}
//             className="px-2 py-1 border rounded hover:bg-gray-100"
//           >
//             ⟳
//           </button>
//         </div>
//       </div>

//       <div className="flex-1 overflow-auto flex items-center justify-center">
//         <Document
//           file={safePreviewLink}
//           onLoadSuccess={({ numPages }) => {
//             setNumPages(numPages)
//             setLoading(false)
//           }}
//           onLoadError={(err) => {
//             console.error('PDF load error:', err)
//             setError(true)
//             setLoading(false)
//           }}
//           loading={<Spinner />}
//         >
//           <Page
//             pageNumber={pageNumber}
//             scale={scale}
//             rotate={rotation}
//             renderAnnotationLayer={false}
//             renderTextLayer={false}
//           />
//         </Document>
//       </div>
//     </div>
//   )

//   // 🧩 Office / Word / Excel / PowerPoint
//   const getOfficeViewerUrl = (srcUrl, mime) => {
//     if (!srcUrl) return null
//     const encoded = encodeURIComponent(srcUrl)
//     const officeExts = ['doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx']
//     if (officeExts.some((ext) => name.toLowerCase().endsWith(ext)))
//       return `https://view.officeapps.live.com/op/embed.aspx?src=${encoded}`
//     return `https://docs.google.com/gview?url=${encoded}&embedded=true`
//   }

//   const renderOffice = () => {
//     const url = getOfficeViewerUrl(previewLink, type)
//     if (!url)
//       return (
//         <div className="flex items-center justify-center p-10">
//           No preview available
//         </div>
//       )
//     return (
//       <div className="flex-1 h-[75vh]">
//         <iframe
//           ref={iframeRef}
//           src={url}
//           title={name}
//           className="w-full h-full border"
//           loading="lazy"
//         />
//       </div>
//     )
//   }

//   const renderImage = () => (
//     <div className="flex-1 h-[75vh] flex items-center justify-center bg-gray-50">
//       <img
//         src={previewLink}
//         alt={name}
//         className="max-h-[75vh] max-w-full object-contain rounded shadow"
//         onLoad={() => setLoading(false)}
//         onError={() => setError(true)}
//       />
//     </div>
//   )

//   const renderVideo = () => (
//     <div className="flex-1 h-[75vh] flex items-center justify-center bg-black">
//       <video
//         controls
//         className="max-h-[75vh] max-w-full"
//         onLoadedData={() => setLoading(false)}
//         onError={() => setError(true)}
//       >
//         <source src={previewLink} type={type} />
//         Your browser does not support video playback.
//       </video>
//     </div>
//   )

//   const renderFallback = () => (
//     <div className="flex-1 h-[75vh] flex flex-col items-center justify-center bg-gray-50">
//       <div className="text-6xl mb-2">📎</div>
//       <h3 className="text-lg font-semibold">{name}</h3>
//       <p className="text-sm text-gray-600 mt-2">
//         Preview not available for this file type.
//       </p>
//       <div className="mt-4 flex gap-2">
//         <button
//           onClick={() => openInNewTab(previewLink)}
//           className="px-4 py-2 bg-gray-100 rounded border"
//         >
//           Open
//         </button>
//         <button
//           onClick={handleDownload}
//           className="px-4 py-2 bg-blue-600 text-white rounded flex items-center gap-2"
//         >
//           <Download size={14} /> Download
//         </button>
//       </div>
//     </div>
//   )

//   const renderByType = () => {
//     const lower = (type || '').toLowerCase()
//     const ext = (name || '').split('.').pop()?.toLowerCase()

//     if (lower === 'application/pdf' || ext === 'pdf') return renderPDF()
//     if (
//       lower.startsWith('image/') ||
//       ['png', 'jpg', 'jpeg', 'gif', 'webp', 'svg'].includes(ext)
//     )
//       return renderImage()
//     if (
//       lower.startsWith('video/') ||
//       ['mp4', 'webm', 'mov', 'avi'].includes(ext)
//     )
//       return renderVideo()
//     if (
//       ['doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx'].includes(ext) ||
//       lower.includes('officedocument')
//     )
//       return renderOffice()
//     return renderFallback()
//   }

//   return (
//     <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60">
//       <div className="bg-white rounded-lg shadow-xl w-[95vw] h-[95vh] overflow-hidden flex flex-col">
//         {/* Header */}
//         <div className="flex items-center justify-between p-4 border-b">
//           <div className="flex items-center gap-3">
//             <div className="text-2xl">📎</div>
//             <div>
//               <div className="font-semibold">{name}</div>
//               <div className="text-xs text-gray-500">
//                 {file.size || 'Unknown size'} • {file.uploadDate || ''}
//               </div>
//             </div>
//           </div>
//           <div className="flex items-center gap-2">
//             <button
//               onClick={() => openInNewTab(previewLink)}
//               className="px-3 py-1 rounded hover:bg-gray-100 text-sm flex items-center gap-2"
//             >
//               <ArrowUpRight size={14} /> Open
//             </button>
//             <button
//               onClick={handleDownload}
//               className="px-3 py-1 rounded hover:bg-gray-100 text-sm flex items-center gap-2"
//             >
//               <Download size={14} /> Download
//             </button>
//             <button
//               onClick={handlePrint}
//               title="Print"
//               className="px-3 py-1 rounded hover:bg-gray-100 text-sm flex items-center gap-2"
//             >
//               <Printer size={14} /> Print
//             </button>
//             <button onClick={onClose} className="p-2 rounded hover:bg-gray-100">
//               <X size={18} />
//             </button>
//           </div>
//         </div>

//         {/* Body */}
//         <div className="flex-1 relative">
//           {loading && !error && (
//             <div className="absolute inset-0 z-10 flex items-center justify-center bg-white/80">
//               <Spinner />
//               <div className="text-sm text-gray-600 mt-2">
//                 Loading preview...
//               </div>
//             </div>
//           )}
//           <div className="w-full h-full">{renderByType()}</div>
//         </div>
//       </div>
//     </div>
//   )
// }

// export default FilePreviewModal

import React, { useEffect, useRef, useState } from 'react'
import { Document, Page, pdfjs } from 'react-pdf'
import * as XLSX from 'xlsx'
import * as docxPreview from 'docx-preview'
import {
  Download,
  Printer,
  X,
  ChevronLeft,
  ChevronRight,
  ArrowUpRight,
} from 'lucide-react'

import 'react-pdf/dist/Page/AnnotationLayer.css'
import 'react-pdf/dist/Page/TextLayer.css'

// Ensure workerSrc uses an explicit, compatible pdfjs-dist version.
// Example (works if pdfjs-dist installed and matches react-pdf expectations):
pdfjs.GlobalWorkerOptions.workerSrc = `https://unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`

// If you have your own helper to build full file URLs, import it; otherwise safePreviewLink will be used directly
// import { getFullFileUrl } from '../../../../../utils/devprodswitcher'

const Spinner = () => (
  <div className="flex items-center justify-center p-6">
    <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-gray-300" />
  </div>
)

/**
 * Props:
 *  - file: { name, previewLink, type (mime), size, uploadDate, icon }
 *  - onClose: fn
 *
 * Notes: previewLink should be a publicly fetchable URL or your API proxy URL.
 */
const FilePreviewModal = ({ file, onClose }) => {
  if (!file) return null

  // safePreviewLink: if you need to transform relative path to absolute, do it here.
  // For example: const safePreviewLink = getFullFileUrl(file.previewLink)
  const safePreviewLink = file.previewLink

  const { name, type } = file
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(false)

  // PDF state
  const [numPages, setNumPages] = useState(null)
  const [pageNumber, setPageNumber] = useState(1)
  const [scale, setScale] = useState(1.2)
  const [rotation, setRotation] = useState(0)

  // Inline office state
  const wordContainerRef = useRef(null)
  const excelContainerRef = useRef(null)

  // we keep fetched blob for printing/download cleanup
  const fetchedBlobRef = useRef(null)

  useEffect(() => {
    // reset on file change
    setLoading(true)
    setError(false)
    setNumPages(null)
    setPageNumber(1)
    setScale(1.2)
    setRotation(0)

    // Clear previous inline renderers
    if (wordContainerRef.current) wordContainerRef.current.innerHTML = ''
    if (excelContainerRef.current) excelContainerRef.current.innerHTML = ''
    // fetch data needed for inline office previews (docx/xlsx) asynchronously
    const fetchForInline = async () => {
      try {
        if (!safePreviewLink) {
          setError(true)
          setLoading(false)
          return
        }
        const ext = (name || '').split('.').pop()?.toLowerCase()
        // For docx: fetch arrayBuffer and render using docx-preview
        if (ext === 'docx') {
          const res = await fetch(safePreviewLink)
          if (!res.ok) throw new Error('Failed to fetch docx for preview')
          const ab = await res.arrayBuffer()
          // docxPreview.renderAsync supports arrayBuffer
          if (wordContainerRef.current) {
            // docx-preview appends; the library returns a promise
            await docxPreview.renderAsync(ab, wordContainerRef.current, null)
          }
        } else if (ext === 'xlsx' || ext === 'xls' || ext === 'csv') {
          // fetch as arrayBuffer (xls/xlsx) or text (csv)
          const res = await fetch(safePreviewLink)
          if (!res.ok)
            throw new Error('Failed to fetch spreadsheet for preview')
          const contentType = res.headers.get('content-type') || ''
          if (contentType.includes('text') || ext === 'csv') {
            const txt = await res.text()
            renderCsvToContainer(txt, excelContainerRef.current)
          } else {
            const ab = await res.arrayBuffer()
            renderWorkbookToContainer(ab, excelContainerRef.current)
          }
        }
        // store a blob for printing/download convenience (for PDF printing)
        // fetch and store blob for print/download reuse
        const blobRes = await fetch(safePreviewLink)
        if (blobRes.ok) {
          const blob = await blobRes.blob()
          fetchedBlobRef.current &&
            URL.revokeObjectURL(fetchedBlobRef.current.objectUrl)
          fetchedBlobRef.current = {
            blob,
            objectUrl: URL.createObjectURL(blob),
          }
        }
      } catch (err) {
        console.warn('Inline fetch/render error:', err)
        // don't fail whole preview for viewer fallbacks
      } finally {
        // small delay to keep UX smooth
        setTimeout(() => setLoading(false), 200)
      }
    }

    fetchForInline()

    return () => {
      // cleanup blob URLs
      if (fetchedBlobRef.current) {
        try {
          URL.revokeObjectURL(fetchedBlobRef.current.objectUrl)
        } catch (e) {}
        fetchedBlobRef.current = null
      }
      // clear containers
      if (wordContainerRef.current) wordContainerRef.current.innerHTML = ''
      if (excelContainerRef.current) excelContainerRef.current.innerHTML = ''
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [safePreviewLink, name])

  // helpers for spreadsheet rendering
  const renderWorkbookToContainer = (arrayBuffer, container) => {
    try {
      const workbook = XLSX.read(arrayBuffer, { type: 'array' })
      // render first sheet to HTML table
      const sheetName = workbook.SheetNames[0]
      const worksheet = workbook.Sheets[sheetName]
      const html = XLSX.utils.sheet_to_html(worksheet, { id: 'sheet-preview' })
      if (container) container.innerHTML = html
    } catch (err) {
      if (container)
        container.innerHTML = `<div class="p-4 text-sm text-red-600">Error rendering spreadsheet</div>`
      console.error('spreadsheet render error', err)
    }
  }

  const renderCsvToContainer = (csvText, container) => {
    try {
      const workbook = XLSX.read(csvText, { type: 'string' })
      const sheetName = workbook.SheetNames[0]
      const worksheet = workbook.Sheets[sheetName]
      const html = XLSX.utils.sheet_to_html(worksheet, { id: 'sheet-preview' })
      if (container) container.innerHTML = html
    } catch (err) {
      if (container)
        container.innerHTML = `<div class="p-4 text-sm text-red-600">Error rendering CSV</div>`
      console.error('csv render error', err)
    }
  }

  // open the url in a new tab (viewer)
  const openInNewTab = (url) => {
    if (!url) return
    window.open(url, '_blank', 'noopener,noreferrer')
  }

  // Build Office viewer URLs (Office Live / Google Viewer) for fallback/open
  const getOfficeViewerUrl = (srcUrl) => {
    if (!srcUrl) return null
    const encoded = encodeURIComponent(srcUrl)
    // prefer Office viewer for docx/xlsx/pptx; google as fallback
    return `https://view.officeapps.live.com/op/embed.aspx?src=${encoded}`
  }

  // PRINT handling - robust approach:
  // - If we pre-fetched blob (PDF or other content), open blob URL and call print()
  // - For PDFs: open blob URL and print (better than react-pdf internal print)
  // - For images: open a small HTML window with <img> then print
  // - For Office: open viewer URL (user prints there)
  const handlePrint = async () => {
    if (!safePreviewLink) return

    const ext = (name || '').split('.').pop()?.toLowerCase()
    const mime = (type || '').toLowerCase()

    try {
      // If we already fetched blob, use it
      if (fetchedBlobRef.current?.objectUrl) {
        const objUrl = fetchedBlobRef.current.objectUrl
        // For pdf: open and print
        if (ext === 'pdf' || mime === 'application/pdf') {
          const w = window.open(objUrl, '_blank')
          if (w) {
            // Some browsers won't let script-triggered print due to cross-origin or timing; try
            setTimeout(() => {
              try {
                w.focus()
                w.print()
              } catch (err) {
                console.warn('print window error', err)
              }
            }, 500)
          }
          return
        }
        // For images: open a tiny document with the image
        if (
          (mime || '').startsWith('image/') ||
          ['png', 'jpg', 'jpeg', 'gif', 'webp', 'svg'].includes(ext)
        ) {
          const html = `
            <html><head><title>${name}</title></head>
            <body style="margin:0;display:flex;align-items:center;justify-content:center;">
              <img src="${objUrl}" style="max-width:100%;height:auto;" />
              <script>setTimeout(()=>{ window.print(); }, 300);</script>
            </body></html>`
          const w = window.open('', '_blank')
          if (!w) return
          w.document.write(html)
          w.document.close()
          return
        }
        // Fallback: open blob URL and let user print manually
        const w = window.open(objUrl, '_blank')
        if (w) return
      }

      // If no blob prefetch available: fallback to opening viewer or direct url
      if (ext === 'pdf' || mime === 'application/pdf') {
        const w = window.open(safePreviewLink, '_blank')
        if (w) {
          setTimeout(() => {
            try {
              w.focus()
              w.print()
            } catch (err) {
              console.warn('print error', err)
            }
          }, 600)
        }
        return
      }

      if (
        (mime || '').startsWith('image/') ||
        ['png', 'jpg', 'jpeg', 'gif', 'webp', 'svg'].includes(ext)
      ) {
        const w = window.open('', '_blank')
        if (!w) return
        const html = `
          <html><head><title>${name}</title></head>
          <body style="margin:0;display:flex;align-items:center;justify-content:center;">
            <img src="${safePreviewLink}" style="max-width:100%;height:auto;" />
            <script>setTimeout(()=>{ window.print(); }, 300);</script>
          </body></html>`
        w.document.write(html)
        w.document.close()
        return
      }

      // Office: open Office viewer in new tab and let user print there
      const viewer = getOfficeViewerUrl(safePreviewLink)
      if (viewer) {
        openInNewTab(viewer)
        return
      }

      // Final fallback: open raw link
      openInNewTab(safePreviewLink)
    } catch (err) {
      console.error('print handler error', err)
      openInNewTab(safePreviewLink)
    }
  }

  // DOWNLOAD helper
  const handleDownload = () => {
    if (fetchedBlobRef.current?.objectUrl) {
      const a = document.createElement('a')
      a.href = fetchedBlobRef.current.objectUrl
      a.download = name || 'download'
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
      return
    }
    // fallback direct link
    const a = document.createElement('a')
    a.href = safePreviewLink
    a.download = name || 'download'
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
  }

  // PDF controls
  const zoomIn = () => setScale((s) => Math.min(s + 0.2, 3))
  const zoomOut = () => setScale((s) => Math.max(s - 0.2, 0.5))
  const resetZoom = () => setScale(1.2)
  const rotate = () => setRotation((r) => (r + 90) % 360)

  // Renderers
  const renderPDF = () => {
    return (
      <div className="flex flex-col h-[75vh] bg-gray-50">
        <div className="flex items-center justify-between gap-2 px-3 py-2 border-b bg-white">
          <div className="flex items-center gap-2 text-sm">
            <button
              onClick={() => setPageNumber((p) => Math.max(1, p - 1))}
              disabled={pageNumber <= 1}
              className="p-2 rounded hover:bg-gray-100 disabled:opacity-40"
            >
              <ChevronLeft size={18} />
            </button>
            <span>
              Page {pageNumber} of {numPages || '?'}
            </span>
            <button
              onClick={() =>
                setPageNumber((p) => Math.min(numPages || p, p + 1))
              }
              disabled={numPages ? pageNumber >= numPages : true}
              className="p-2 rounded hover:bg-gray-100 disabled:opacity-40"
            >
              <ChevronRight size={18} />
            </button>
          </div>

          <div className="flex items-center gap-2">
            <button onClick={zoomOut} className="px-2 py-1 border rounded">
              -
            </button>
            <button onClick={resetZoom} className="px-2 py-1 border rounded">
              {Math.round(scale * 100)}%
            </button>
            <button onClick={zoomIn} className="px-2 py-1 border rounded">
              +
            </button>
            <button onClick={rotate} className="px-2 py-1 border rounded">
              ⟳
            </button>
          </div>
        </div>

        <div className="flex-1 overflow-auto flex items-center justify-center">
          <Document
            file={safePreviewLink}
            onLoadSuccess={({ numPages }) => setNumPages(numPages)}
            onLoadError={(err) => {
              console.error('PDF load error:', err)
              setError(true)
            }}
            loading={<Spinner />}
          >
            <Page
              pageNumber={pageNumber}
              scale={scale}
              rotate={rotation}
              renderAnnotationLayer={false}
              renderTextLayer={false}
            />
          </Document>
        </div>
      </div>
    )
  }

  const renderOfficeInline = () => {
    // show docx container OR excel container depending on ext
    const ext = (name || '').split('.').pop()?.toLowerCase()
    if (ext === 'docx') {
      return (
        <div
          ref={wordContainerRef}
          className="p-4 overflow-auto bg-white h-[75vh]"
        />
      )
    }
    if (['xlsx', 'xls', 'csv'].includes(ext)) {
      return (
        <div
          ref={excelContainerRef}
          className="p-4 overflow-auto bg-white h-[75vh] overflow-x-auto"
        />
      )
    }
    // fallback to iframe office viewer
    const viewer = getOfficeViewerUrl(safePreviewLink)
    return (
      <iframe
        title={name}
        src={viewer || safePreviewLink}
        className="w-full h-[75vh] border"
      />
    )
  }

  const renderImage = () => (
    <div className="flex-1 h-[75vh] flex items-center justify-center overflow-auto bg-gray-50">
      <img
        src={safePreviewLink}
        alt={name}
        className="max-h-[75vh] max-w-full object-contain rounded shadow"
        onLoad={() => setLoading(false)}
        onError={() => setError(true)}
      />
    </div>
  )

  const renderVideo = () => (
    <div className="flex-1 h-[75vh] flex items-center justify-center bg-black">
      <video
        controls
        className="max-h-[75vh] max-w-full"
        onLoadedData={() => setLoading(false)}
        onError={() => setError(true)}
      >
        <source src={safePreviewLink} type={type} />
        Your browser does not support video playback.
      </video>
    </div>
  )

  const renderAudio = () => (
    <div className="flex-1 h-40 flex items-center justify-center bg-gray-50">
      <audio
        controls
        src={safePreviewLink}
        onLoadedData={() => setLoading(false)}
      />
    </div>
  )

  const renderText = () => (
    <div className="flex-1 h-[75vh] overflow-auto bg-white p-6 prose max-w-none">
      <RemoteTextViewer url={safePreviewLink} onError={() => setError(true)} />
    </div>
  )

  const renderFallback = () => (
    <div className="flex-1 h-[75vh] flex items-center justify-center bg-gray-50">
      <div className="text-center">
        <div className="text-6xl mb-2">📎</div>
        <h3 className="text-lg font-semibold">{name}</h3>
        <p className="text-sm text-gray-600 mt-2">
          Preview not available for this file type.
        </p>
        <div className="mt-4 flex gap-2 justify-center">
          <button
            onClick={() =>
              openInNewTab(
                getOfficeViewerUrl(safePreviewLink) || safePreviewLink
              )
            }
            className="px-4 py-2 bg-gray-100 rounded border"
          >
            Open Viewer
          </button>
          <button
            onClick={handleDownload}
            className="px-4 py-2 bg-blue-600 text-white rounded flex items-center gap-2"
          >
            <Download size={14} /> Download
          </button>
        </div>
      </div>
    </div>
  )

  const renderByType = () => {
    const lower = (type || '').toLowerCase()
    const ext = (name || '').split('.').pop()?.toLowerCase()

    if (lower === 'application/pdf' || ext === 'pdf') return renderPDF()
    if (
      (lower || '').startsWith('image/') ||
      ['png', 'jpg', 'jpeg', 'gif', 'webp', 'svg'].includes(ext)
    )
      return renderImage()
    if (
      (lower || '').startsWith('video/') ||
      ['mp4', 'webm', 'mov', 'avi'].includes(ext)
    )
      return renderVideo()
    if (
      (lower || '').startsWith('audio/') ||
      ['mp3', 'wav', 'ogg'].includes(ext)
    )
      return renderAudio()
    if ((lower || '').startsWith('text/') || ['txt', 'md'].includes(ext))
      return renderText()
    if (
      ['doc', 'docx', 'xls', 'xlsx', 'csv'].includes(ext) ||
      lower.includes('officedocument') ||
      lower.includes('msword') ||
      lower.includes('vnd.ms')
    ) {
      return renderOfficeInline()
    }
    return renderFallback()
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60">
      <div className="bg-white rounded-lg shadow-xl w-[95vw] h-[95vh] overflow-hidden flex flex-col">
        {/* Header */}
        <div className="flex items-center justify-between p-4 border-b">
          <div className="flex items-center gap-3">
            <div className="text-2xl">📎</div>
            <div>
              <div className="font-semibold">{name}</div>
              <div className="text-xs text-gray-500">
                {file.size || 'Unknown size'} • {file.uploadDate || ''}
              </div>
            </div>
          </div>

          <div className="flex items-center gap-2">
            <button
              onClick={() =>
                // openInNewTab(
                //   getOfficeViewerUrl(safePreviewLink) || safePreviewLink
                // )
                openInNewTab(
                  safePreviewLink || getOfficeViewerUrl(safePreviewLink)
                )
              }
              className="px-3 py-1 rounded hover:bg-gray-100 text-sm flex items-center gap-2"
            >
              <ArrowUpRight size={14} /> Open
            </button>
            <button
              onClick={handleDownload}
              className="px-3 py-1 rounded hover:bg-gray-100 text-sm flex items-center gap-2"
            >
              <Download size={14} /> Download
            </button>
            <button
              onClick={handlePrint}
              title="Print"
              className="px-3 py-1 rounded hover:bg-gray-100 text-sm flex items-center gap-2"
            >
              <Printer size={14} /> Print
            </button>
            <button onClick={onClose} className="p-2 rounded hover:bg-gray-100">
              <X size={18} />
            </button>
          </div>
        </div>

        {/* Body */}
        <div className="flex-1 relative">
          {loading && !error && (
            <div className="absolute inset-0 z-10 flex items-center justify-center bg-white/80">
              <Spinner />
              <div className="text-sm text-gray-600 mt-2">
                Loading preview...
              </div>
            </div>
          )}

          <div className="w-full h-full">{renderByType()}</div>
        </div>
      </div>
    </div>
  )
}

export default FilePreviewModal

/* RemoteTextViewer component used for text-like previews */
function RemoteTextViewer({ url, onError }) {
  const [text, setText] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    let mounted = true
    const load = async () => {
      try {
        setLoading(true)
        const res = await fetch(url)
        if (!res.ok) throw new Error('failed to fetch text')
        const contentType = res.headers.get('content-type') || ''
        if (contentType.includes('text') || contentType.includes('json')) {
          const txt = await res.text()
          if (mounted) setText(txt)
        } else {
          if (mounted) setText(null)
          onError && onError()
        }
      } catch (err) {
        console.error('Error fetching remote text', err)
        onError && onError()
      } finally {
        mounted && setLoading(false)
      }
    }
    load()
    return () => (mounted = false)
  }, [url, onError])

  if (loading) return <Spinner />
  if (!text)
    return <div className="p-6 text-gray-600">Unable to preview text file.</div>

  return (
    <pre className="p-6 whitespace-pre-wrap break-words text-sm text-gray-800">
      {text}
    </pre>
  )
}

// import { useEffect, useRef, useState } from 'react'
// import { Document, Page, pdfjs } from 'react-pdf'
// import {
//   Download,
//   Printer,
//   X,
//   ChevronLeft,
//   ChevronRight,
//   ArrowUpRight,
// } from 'lucide-react'

// import 'react-pdf/dist/Page/AnnotationLayer.css'
// import 'react-pdf/dist/Page/TextLayer.css'
// import { getFullFileUrl } from '../../../../../utils/devprodswitcher'

// const API_BASE = 'http://localhost:8000' // 🔁 change to your backend URL in prod

// pdfjs.GlobalWorkerOptions.workerSrc = `https://unpkg.com/pdfjs-dist@4.4.168/build/pdf.worker.min.mjs`

// const Spinner = () => (
//   <div className="flex items-center justify-center p-6">
//     <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-gray-300" />
//   </div>
// )

// const FilePreviewModal = ({ file, onClose }) => {
//   if (!file) return null

//   const safePreviewLink = getFullFileUrl(file.previewLink)
//   const { name, type } = file

//   const [loading, setLoading] = useState(true)
//   const [error, setError] = useState(false)
//   const [numPages, setNumPages] = useState(null)
//   const [pageNumber, setPageNumber] = useState(1)
//   const [scale, setScale] = useState(1.2)
//   const [rotation, setRotation] = useState(0)
//   const iframeRef = useRef(null)

//   useEffect(() => {
//     setLoading(true)
//     setError(false)
//     setTimeout(() => setLoading(false), 400)
//   }, [file])

//   // ✅ Print logic
//   const handlePrint = () => {
//     if (!safePreviewLink) return

//     const mime = type?.toLowerCase() || ''
//     const fileUrl = safePreviewLink

//     if (mime === 'application/pdf' || name.endsWith('.pdf')) {
//       const w = window.open(fileUrl, '_blank')
//       if (w) w.addEventListener('load', () => w.print())
//       return
//     }

//     if (mime.startsWith('image/')) {
//       const w = window.open('', '_blank')
//       if (!w) return
//       const html = `
//         <html><body style="margin:0;display:flex;align-items:center;justify-content:center;">
//           <img src="${fileUrl}" style="max-width:100%;height:auto;" />
//           <script>setTimeout(()=>window.print(),500)</script>
//         </body></html>`
//       w.document.write(html)
//       w.document.close()
//       return
//     }

//     const viewer = getOfficeViewerUrl(fileUrl, mime)
//     window.open(viewer, '_blank')
//   }

//   const handleDownload = () => {
//     if (!safePreviewLink) return
//     const a = document.createElement('a')
//     a.href = safePreviewLink
//     a.download = name || 'download'
//     document.body.appendChild(a)
//     a.click()
//     document.body.removeChild(a)
//   }

//   const zoomIn = () => setScale((s) => Math.min(s + 0.2, 3))
//   const zoomOut = () => setScale((s) => Math.max(s - 0.2, 0.5))
//   const resetZoom = () => setScale(1.2)
//   const rotate = () => setRotation((r) => (r + 90) % 360)

//   const renderPDF = () => (
//     <div className="flex flex-col h-[75vh] bg-gray-50">
//       <div className="flex items-center justify-between gap-2 px-3 py-2 border-b bg-white">
//         <div className="flex items-center gap-2 text-sm">
//           <button
//             onClick={() => setPageNumber((p) => Math.max(1, p - 1))}
//             disabled={pageNumber <= 1}
//             className="p-2 rounded hover:bg-gray-100 disabled:opacity-40"
//           >
//             <ChevronLeft size={18} />
//           </button>
//           <span>
//             Page {pageNumber} of {numPages || '?'}
//           </span>
//           <button
//             onClick={() => setPageNumber((p) => Math.min(numPages || p, p + 1))}
//             disabled={numPages ? pageNumber >= numPages : true}
//             className="p-2 rounded hover:bg-gray-100 disabled:opacity-40"
//           >
//             <ChevronRight size={18} />
//           </button>
//         </div>

//         <div className="flex items-center gap-2">
//           <button
//             onClick={zoomOut}
//             className="px-2 py-1 border rounded hover:bg-gray-100"
//           >
//             -
//           </button>
//           <button
//             onClick={resetZoom}
//             className="px-2 py-1 border rounded hover:bg-gray-100"
//           >
//             {Math.round(scale * 100)}%
//           </button>
//           <button
//             onClick={zoomIn}
//             className="px-2 py-1 border rounded hover:bg-gray-100"
//           >
//             +
//           </button>
//           <button
//             onClick={rotate}
//             className="px-2 py-1 border rounded hover:bg-gray-100"
//           >
//             ⟳
//           </button>
//         </div>
//       </div>

//       <div className="flex-1 overflow-auto flex items-center justify-center">
//         <Document
//           file={safePreviewLink}
//           onLoadSuccess={({ numPages }) => setNumPages(numPages)}
//           onLoadError={(err) => {
//             console.error('PDF load error:', err)
//             setError(true)
//           }}
//           loading={<Spinner />}
//         >
//           <Page
//             pageNumber={pageNumber}
//             scale={scale}
//             rotate={rotation}
//             renderAnnotationLayer={false}
//             renderTextLayer={false}
//           />
//         </Document>
//       </div>
//     </div>
//   )

//   // ✅ OFFICE VIEWER with fallback to Google Viewer
//   const getOfficeViewerUrl = (srcUrl, mime) => {
//     const encodedProxy = encodeURIComponent(
//       `${API_BASE}?url=${encodeURIComponent(srcUrl)}`
//     )
//     return `https://view.officeapps.live.com/op/embed.aspx?src=${encodedProxy}`
//   }

//   const getGoogleViewerUrl = (srcUrl) => {
//     const encodedProxy = encodeURIComponent(
//       `${API_BASE}/proxy/?url=${encodeURIComponent(srcUrl)}`
//     )
//     return `https://docs.google.com/gview?url=${encodedProxy}&embedded=true`
//   }

//   const renderOffice = () => {
//     const officeUrl = getOfficeViewerUrl(safePreviewLink, type)
//     const googleUrl = getGoogleViewerUrl(safePreviewLink)

//     return (
//       <iframe
//         ref={iframeRef}
//         src={officeUrl}
//         title={name}
//         className="w-full h-[75vh] border"
//         loading="lazy"
//         onError={() => {
//           if (iframeRef.current) {
//             iframeRef.current.src = googleUrl
//           }
//         }}
//       />
//     )
//   }

//   const renderImage = () => (
//     <div className="flex-1 h-[75vh] flex items-center justify-center overflow-auto bg-gray-50">
//       <img
//         src={safePreviewLink}
//         alt={name}
//         className="max-h-[75vh] max-w-full object-contain rounded shadow"
//         onError={() => setError(true)}
//       />
//     </div>
//   )

//   const renderVideo = () => (
//     <div className="flex-1 h-[75vh] flex items-center justify-center bg-black">
//       <video controls className="max-h-[75vh] max-w-full">
//         <source src={safePreviewLink} type={type} />
//       </video>
//     </div>
//   )

//   const renderByType = () => {
//     const ext = (name || '').split('.').pop()?.toLowerCase()
//     const mime = (type || '').toLowerCase()

//     if (mime === 'application/pdf' || ext === 'pdf') return renderPDF()
//     if (
//       mime.startsWith('image/') ||
//       ['png', 'jpg', 'jpeg', 'gif', 'webp'].includes(ext)
//     )
//       return renderImage()
//     if (
//       mime.startsWith('video/') ||
//       ['mp4', 'webm', 'mov', 'avi'].includes(ext)
//     )
//       return renderVideo()
//     if (['doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx'].includes(ext))
//       return renderOffice()
//     return (
//       <div className="flex items-center justify-center h-[75vh] text-gray-500">
//         Preview not available
//       </div>
//     )
//   }

//   return (
//     <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60">
//       <div className="bg-white rounded-lg shadow-xl w-[95vw] h-[95vh] overflow-hidden flex flex-col">
//         <div className="flex items-center justify-between p-4 border-b">
//           <div className="flex items-center gap-3">
//             <div className="text-2xl">📎</div>
//             <div>
//               <div className="font-semibold">{name}</div>
//               <div className="text-xs text-gray-500">
//                 {file.size || 'Unknown size'}
//               </div>
//             </div>
//           </div>

//           <div className="flex items-center gap-2">
//             <button
//               onClick={handleDownload}
//               className="px-3 py-1 rounded hover:bg-gray-100 flex items-center gap-2"
//             >
//               <Download size={14} /> Download
//             </button>
//             <button
//               onClick={handlePrint}
//               className="px-3 py-1 rounded hover:bg-gray-100 flex items-center gap-2"
//             >
//               <Printer size={14} /> Print
//             </button>
//             <button onClick={onClose} className="p-2 rounded hover:bg-gray-100">
//               <X size={18} />
//             </button>
//           </div>
//         </div>

//         <div className="flex-1 relative bg-gray-50">
//           {loading && (
//             <div className="absolute inset-0 flex flex-col items-center justify-center bg-white/80">
//               <Spinner />
//               <div className="text-sm text-gray-600 mt-2">
//                 Loading preview...
//               </div>
//             </div>
//           )}
//           <div className="w-full h-full">{renderByType()}</div>
//         </div>
//       </div>
//     </div>
//   )
// }

// export default FilePreviewModal
